
const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-teal-600 text-white py-24">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl lg:text-6xl font-bold mb-6">
          Product Expertise
        </h1>
        <p className="text-xl lg:text-2xl max-w-4xl mx-auto leading-relaxed">
          As authorized partners, we provide deep expertise across leading enterprise platforms to deliver integrated solutions that transform your IT operations.
        </p>
      </div>
    </section>
  );
};

export default Hero;
